import { TraceXInterceptor } from '@trace-x/trace-x-generator';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TariffHotelCriteria } from './models/tariff-accom-criteria';

@Injectable({
  providedIn: 'root'
})
export class SurfTariffSearchService {

  private tariffHotelCriteriaSubject = new BehaviorSubject<TariffHotelCriteria>(null);
  private tariffHotelResultsSubject = new BehaviorSubject<any>([]);

  // loading state
  private loadingResultSubject = new BehaviorSubject<boolean>(false);

  constructor() { }


  setTariffHotelCriteria(criteria: TariffHotelCriteria) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tariff-search/src/lib/surf-tariff-search.service.ts.SurfTariffSearchService.setTariffHotelCriteria');
    this.tariffHotelCriteriaSubject.next(criteria);
  }

  getTariffHotelCriteria() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tariff-search/src/lib/surf-tariff-search.service.ts.SurfTariffSearchService.getTariffHotelCriteria');
    return this.tariffHotelCriteriaSubject.asObservable();
  }

  // get the current value of the criteria
  getTariffHotelCriteriaValue() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tariff-search/src/lib/surf-tariff-search.service.ts.SurfTariffSearchService.getTariffHotelCriteriaValue');
    return this.tariffHotelCriteriaSubject.getValue();
  }

  setTariffHotelResults(results: any) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tariff-search/src/lib/surf-tariff-search.service.ts.SurfTariffSearchService.setTariffHotelResults');
    this.tariffHotelResultsSubject.next(results);
  }

  getTariffHotelResults() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tariff-search/src/lib/surf-tariff-search.service.ts.SurfTariffSearchService.getTariffHotelResults');
    return this.tariffHotelResultsSubject.asObservable();
  }

  setLoadingResult(loading: boolean) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tariff-search/src/lib/surf-tariff-search.service.ts.SurfTariffSearchService.setLoadingResult');
    this.loadingResultSubject.next(loading);
  }

  getLoadingResult() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tariff-search/src/lib/surf-tariff-search.service.ts.SurfTariffSearchService.getLoadingResult');
    return this.loadingResultSubject.asObservable();
  }
}
